import * as React from 'react';

import type { WosIconProps } from 'types/common_types';

function xpozer(props: WosIconProps) {
  const { className } = props;

  return (
    <svg viewBox="0 0 79 60" className={className}>
      <path
        fill="currentColor"
        d="M77.368 0h-75.789c-0.842 0-1.579 0.737-1.579 1.579v56.842c0 0.842 0.737 1.579 1.579 1.579h75.789c0.842 0 1.579-0.737 1.579-1.579v-56.842c0-0.842-0.737-1.579-1.579-1.579zM75.789 56.842h-72.632v-53.684h72.632v53.684z"
      />
      <path
        fill="currentColor"
        d="M14.737 52.632v-22.105h4.211v1.053h41.053v-1.053h4.211v22.105h7.368v-7.368l-4.211 4.211v-38.947l4.211 4.211v-7.368h-7.368v22.105h-4.211v-1.053h-41.053v1.053h-4.211v-22.105h-7.368v7.368l4.211-4.211v38.947l-4.211-4.211v7.368z"
      />
    </svg>
  );
}

export default xpozer;
